function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9,28.555A12.073,12.073,0,0,0,28.9,16.561,12,12,0,1,0,16.9,28.555Zm0-2.39a9.6,9.6,0,1,1,9.6-9.6A9.56,9.56,0,0,1,16.9,26.165Zm0-10a3.038,3.038,0,0,0,2.935-3.213A3.055,3.055,0,0,0,16.9,9.81a3.057,3.057,0,0,0-2.946,3.144A3.054,3.054,0,0,0,16.9,16.166ZM11.77,22.36H22.013a.728.728,0,0,0,.754-.812c0-1.253-1.856-4.478-5.87-4.478s-5.881,3.225-5.881,4.478A.728.728,0,0,0,11.77,22.36Z",
  transform: "translate(-4.903 -4.566)"
});

function SvgEmailFromUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFromUser);
export default __webpack_public_path__ + "static/media/email_from_user.b5aad351.svg";
export { ForwardRef as ReactComponent };